var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoweigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2239 21.5699H3.85669C3.64095 21.5699 3.43223 21.4647 3.30688 21.2975C3.17465 21.1232 3.12533 20.9002 3.18091 20.691L6.1897 9.5885C6.19335 9.5751 6.19901 9.56246 6.20337 9.54944L18.2239 21.5699ZM11.6213 2.0426C13.2572 2.04299 14.5871 3.37469 14.5872 5.01331C14.5871 6.41466 13.6193 7.57904 12.3176 7.89319V9.0719H16.3772C16.6971 9.07226 16.9685 9.28191 17.052 9.5885L19.8879 20.0524L8.90747 9.0719H10.925V7.89319C9.62286 7.5794 8.65456 6.41503 8.65454 5.01331C8.6546 3.3746 9.98515 2.04263 11.6213 2.0426ZM11.6204 3.43713C10.7501 3.43733 10.0471 4.14865 10.0471 5.01331C10.0472 5.63378 10.4091 6.16342 10.9241 6.42151V5.55042C10.9241 5.15999 11.2375 4.85334 11.6204 4.85315C12.0032 4.85337 12.3167 5.16001 12.3167 5.55042V6.42151C12.8317 6.16341 13.1945 5.63379 13.1946 5.01331C13.1946 4.14867 12.4906 3.43736 11.6204 3.43713Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.1121,
    y1: 6.85677,
    x2: 20.4312,
    y2: 22.1759,
    stroke: "#E60004"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoweigh);
export default __webpack_public_path__ + "static/media/noweigh.93f3a6321290ec454015b852d0c6ed81.svg";
export { ForwardRef as ReactComponent };